import { useTranslation } from "react-i18next";
import { normalizeLocale } from "@/i18n";

export type T = (key: string, values?: Record<string, string | number>) => string;

export const path = (locale: string, value = "") => `/${locale}${value}`;

export function usePage() {
    const { t, i18n } = useTranslation();
    return { t: t as T, locale: normalizeLocale(i18n.language) };
}
